/*
  KP: THE DELIVERY ESTIMATE on product pages. This is the only file to edit to change what
  it says. The box is drawn by assets/kp-delivery.js (which reads this) and styled by
  assets/kp-delivery.css.

  WHAT IT LOOKS LIKE (redesigned 23 Oct 2026, delivery information only, no offers):
      Delivery to United Kingdom                     Change
      Standard delivery                     29 Oct – 3 Nov
      Express delivery                         27 – 30 Oct
      ------------------------------------------------------
      [van] Free delivery over £65
      (small grey line where true, e.g. "Duties paid: no customs fees on delivery")
      Shipping & returns        (opens a pop-up with the shipping and refund policies)
  The Express price is deliberately not shown (it is shown at checkout).

  DELIVERY TIMES, from real orders:
    - Phone cases and tech (Podbase, from Lithuania): 36 tracked orders from 15 Sep - 2 Oct
      2026, working days from order to delivery: UK 4-7 (typically 5), US 5-9 (7), Canada
      5-12 (10), Australia 8-14 (11), Germany/Netherlands/Denmark 3-5, Italy 8-9,
      Norway/Switzerland 6-12 (7).
    - Prints (Prodigi) and WOYC from Shopify's delivery data, Aug-Oct 2026: prints to the US
      typically 5 (9 at most), to Australia 4 (7), WOYC in the UK 3 (6).
    - Express (live 23 Oct 2026): no orders yet to check against. Check these once there
      are some.
  Counted in WORKING DAYS (Saturdays and Sundays are skipped, see skipDays).
  The checkout descriptions (Shopify admin > Shipping and delivery) say the same days. Change
  both together.

  PRODUCT GROUPS (worked out by kp-delivery.js from the product):
    case   phone cases                       (Podbase)
    tech   iPad, AirPods, wallets, ring holders, straps, screen protectors (Podbase)
    woyc   power banks, shells, water bottles, the MagSafe ring upgrade (WOYC)
    print  prints, framed prints, wall hangings; mug: mugs (Prodigi / Gelato)
  Express is never shown for prints or mugs (no Express rate at checkout), and for WOYC
  only in the UK, US and Australia (elsewhere WOYC ships standard).

  FREE SHIPPING AMOUNTS: window.KP_FREESHIP in snippets/kp-cart.liquid is the ONE list used
  here, in the basket bar and in the footer. Change them there, and only to match the
  automatic discounts in Shopify admin > Discounts.
*/
(function () {
  // EU zones, the same three as checkout (Shopify admin > Shipping > General profile:
  // "EU (fast)", "EU (middle)", "EU (slower)"). Set 25 Oct 2026 from ~120 real Podbase orders
  // (17track delivery dates, order to delivery in working days): DE 3-6 (typ. 4), NL 4-6,
  // FR 4-6, SE 3-6 | BE 4-7, DK 4-9, AT 4-10, IE 4-9 (typ. 6), ES 5-13 (typ. 7), PT 6-8,
  // IT 5-8, FI 5-8. No data yet for the eastern and southern countries listed below.
  var EU_FAST = ['DE', 'NL', 'FR', 'SE', 'LU'];
  var EU_MID = ['BE', 'DK', 'AT', 'IE', 'ES', 'PT', 'IT', 'FI', 'PL', 'CZ', 'SK', 'SI', 'HU', 'EE', 'LV', 'LT', 'MC'];
  var EU_SLOW = ['GR', 'RO', 'BG', 'HR', 'MT', 'UA'];
  var EU_MEMBERS = EU_FAST.concat(EU_MID, ['GR', 'RO', 'BG', 'HR', 'MT', 'CY']).filter(function (c) { return c !== 'MC'; });

  // Countries in each delivery zone.
  var ZONES = {
    GB: ['GB'], US: ['US'], CA: ['CA'], AU: ['AU'],
    EUF: EU_FAST, EUM: EU_MID, EUS: EU_SLOW,
    NOCH: ['NO', 'CH'], JE: ['JE'],
    // Same countries as checkout's Worldwide and Singapore zones (Cyprus and Turkey are there too).
    ROW: ['GE', 'HK', 'IS', 'IM', 'IL', 'JP', 'MY', 'QA', 'SG', 'AE', 'VN', 'NZ', 'CY', 'TR', 'AL', 'KR']
  };

  // Standard delivery, working days [soonest, latest], per group and zone.
  var PODBASE = { GB: [4, 7], US: [5, 9], CA: [7, 12], AU: [8, 14], EUF: [3, 6], EUM: [5, 9], EUS: [6, 10], NOCH: [6, 12], JE: [6, 10], ROW: [7, 14] };
  var DAYS = {
    case: PODBASE,
    tech: PODBASE,
    woyc: { GB: [2, 6], US: [4, 8], CA: [7, 12], AU: [3, 8], EUF: [5, 10], EUM: [5, 10], EUS: [5, 10], NOCH: [7, 12], JE: [7, 14], ROW: [7, 14] },
    print: { GB: [3, 6], US: [4, 9], CA: [6, 12], AU: [3, 7], EUF: [5, 10], EUM: [5, 10], EUS: [5, 10], NOCH: [6, 12], JE: [5, 10], ROW: [7, 14] }
  };
  DAYS.mug = DAYS.print;

  // Express, working days [soonest, latest]: production (1-3 days) plus the express courier.
  // Shown as a range like Standard, so it never looks slower: in every zone Express starts no
  // later and ends earlier than Standard. Keep it that way when changing these.
  // Leave a zone out for no Express row.
  // 25 Oct 2026: US/CA and AU corrected to Podbase's published times (made in 1-3 days,
  // then express transit US/CA 3-4, Oceania 2-3). Checkout descriptions say the same.
  var PODBASE_EX = { GB: [2, 5], US: [4, 7], CA: [4, 7], AU: [3, 6], EUF: [2, 5], EUM: [2, 5], EUS: [2, 5], NOCH: [2, 5], JE: [2, 5], ROW: [4, 7] };
  var EXPRESS = { case: PODBASE_EX, tech: PODBASE_EX, woyc: { GB: [2, 4], US: [2, 5], AU: [2, 4] }, print: {}, mug: {} };

  // The small grey line, only where it is true. Podbase pays US duties and ships from the
  // EU (Lithuania), so EU customers pay no customs. Shown for EU member countries only.
  var DUTIES = {
    case: { US: 'Duties paid: no customs fees on delivery', EU: 'Ships from the EU: no customs or duties to pay' }
  };
  DUTIES.tech = DUTIES.case;

  var rules = [];
  ['case', 'tech', 'woyc', 'print', 'mug'].forEach(function (group) {
    Object.keys(ZONES).forEach(function (zone) {
      var days = DAYS[group][zone];
      if (!days) return;
      ZONES[zone].forEach(function (country) {
        var d = DUTIES[group] || {};
        var note = zone === 'US' ? d.US : EU_MEMBERS.indexOf(country) !== -1 ? d.EU : '';
        rules.push({
          groups: [group],
          countries: [country],
          days: days,
          express: EXPRESS[group][zone] || null,
          note: note || ''
        });
      });
    });
  });

  window.KP_DELIVERY = {
    timeZone: 'Europe/London',
    skipDays: ['Saturday', 'Sunday'],
    holidays: ['12-25', '12-26', '01-01'],
    fallbackCountry: 'GB',
    // The "Shipping & returns" pop-up shows these pages' text. Empty = no link (25 Oct 2026,
    // Sana: no shipping & returns link in the box). To bring it back:
    // ['/policies/shipping-policy', '/policies/refund-policy']
    policies: [],
    // true = a "Delivery & returns" link that opens a short summary built from these rules
    // (kp-delivery.js, openSummary). false = no link.
    summary: true,
    rules: rules,

    // The names shown in the country box (it lists them A to Z).
    countryNames: {
      AL: 'Albania', AU: 'Australia', AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria', CA: 'Canada', HR: 'Croatia', CY: 'Cyprus',
      CZ: 'Czechia', DK: 'Denmark', EE: 'Estonia', FI: 'Finland', FR: 'France', GE: 'Georgia', DE: 'Germany',
      GR: 'Greece', HK: 'Hong Kong', HU: 'Hungary', IS: 'Iceland', IE: 'Ireland', IM: 'Isle of Man', IL: 'Israel',
      IT: 'Italy', JP: 'Japan', JE: 'Jersey', LV: 'Latvia', LT: 'Lithuania', LU: 'Luxembourg', MY: 'Malaysia',
      MT: 'Malta', MC: 'Monaco', NL: 'Netherlands', NZ: 'New Zealand', NO: 'Norway', PL: 'Poland', PT: 'Portugal',
      QA: 'Qatar', RO: 'Romania', SG: 'Singapore', SK: 'Slovakia', SI: 'Slovenia', KR: 'South Korea', ES: 'Spain', SE: 'Sweden',
      CH: 'Switzerland', TR: 'Turkey', UA: 'Ukraine', AE: 'United Arab Emirates', GB: 'United Kingdom', US: 'United States',
      VN: 'Vietnam'
    }
  };
})();
